// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__vaHR8","events":"styles_events__3jKOH"};